import * as Yup from "yup";

const CVValidation = Yup.object({
  firstName: Yup.string()
    .trim()
    .required("First Name is Required"),

  middleName: Yup.string()
    .trim()
    .required("Middle Name is Required"),

  lastName: Yup.string()
    .trim()
    .required("Last Name is Required"),

  education: Yup.string()
    .trim()
    .required("Education is Required"),

  experience: Yup.string()
    .trim()
    .required("Experience is Required"),

  contact: Yup.string()
    .required("Contact Number is Required")
    .matches(/^[0-9]{10}$/, "Enter a valid 10 digit contact number"),

  remarks: Yup.string()
    .trim()
    .max(1000, "Remarks cannot exceed 1000 characters"),

  cv: Yup.mixed()
    .nullable()
    .when("id", {
      is: (id) => !id || id === 0,
      then: (schema) =>
        schema.required("Attachment is Required"),
      otherwise: (schema) => schema.nullable(),
    }),
});

export default CVValidation;
